@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.engineservice.cr

import androidx.compose.runtime.*
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.AppDropdown
import org.example.project.settings.UISettings
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun CUSCrNeuesModulForm(
    betreff: String,
    beschreibung: String,
    sendError: String,
    isSending: Boolean,
    onBetreffChange: (String) -> Unit,
    onBeschreibungChange: (String) -> Unit,
    onSubmit: () -> Unit
) {
    Div({
        style {
            width(100.percent)
            maxWidth(980.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(18.px)
            property("margin", "0 auto")
            padding(16.px, 0.px, 32.px, 0.px)
        }
    }) {
        CRInput(betreff, "Betreff", onBetreffChange)
        CRTextArea(beschreibung, "", onBeschreibungChange)
        if (sendError.isNotBlank()) {
            Span({
                style {
                    color(Color.red)
                    fontSize(13.px)
                }
            }) { Text(sendError) }
        }

        Button({
            style {
                marginTop(12.px)
                height(50.px)
                borderRadius(8.px)
                backgroundColor(
                    if (betreff.isNotBlank() && beschreibung.isNotBlank()) Color.white
                    else Color("#1a1c20")
                )
                color(
                    if (betreff.isNotBlank() && beschreibung.isNotBlank()) Color.black
                    else Color("#4a4d54")
                )
                fontWeight("bold")
                cursor("pointer")
                property("border", "none")
            }
            if (betreff.isBlank() || beschreibung.isBlank() || isSending) disabled()
            onClick { onSubmit() }
        }) { Text(if (isSending) "..." else "Anfrage unverbindlich absenden") }
    }
}

@Composable
internal fun CUSCrAenderungForm(
    aktiveScreens: List<All>,
    ladeModule: Boolean,
    gewaehlterScreen: String,
    betreff: String,
    beschreibung: String,
    sendError: String,
    isSending: Boolean,
    onScreenChange: (String) -> Unit,
    onBetreffChange: (String) -> Unit,
    onBeschreibungChange: (String) -> Unit,
    onSubmit: () -> Unit
) {
    Div({
        style {
            width(100.percent)
            maxWidth(980.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(18.px)
            property("margin", "0 auto")
            padding(16.px, 0.px, 32.px, 0.px)
        }
    }) {
        if (ladeModule) {
            Span({
                style {
                    color(DashboardTheme.TEXT_MUTED)
                    fontSize(13.px)
                }
            }) { Text("Aktive Module werden geladen...") }
        }

        AppDropdown(
            options = buildList {
                add(All(key = "", label = "Screen wählen..."))
                addAll(aktiveScreens)
            },
            selectedValue = gewaehlterScreen,
            onChange = onScreenChange,
            attrs = {
                style {
                    width(100.percent)
                    height(46.px)
                    padding(0.px, 16.px)
                    borderRadius(8.px)
                    backgroundColor(Color("#000000"))
                    color(Color.white)
                    property("border", "1px solid #2a2d34")
                }
            }
        )

        if (!ladeModule && aktiveScreens.isEmpty()) {
            Span({
                style {
                    color(DashboardTheme.TEXT_MUTED)
                    fontSize(13.px)
                }
            }) { Text("Für dieses Modul wurden keine aktiven Screens gefunden.") }
        }

        CRInput(betreff, "Betreff", onBetreffChange)
        CRTextArea(beschreibung, "", onBeschreibungChange)
        if (sendError.isNotBlank()) {
            Span({
                style {
                    color(Color.red)
                    fontSize(13.px)
                }
            }) { Text(sendError) }
        }

        Button({
            style {
                marginTop(12.px)
                height(50.px)
                borderRadius(8.px)
                backgroundColor(
                    if (gewaehlterScreen.isNotBlank() && betreff.isNotBlank() && beschreibung.isNotBlank()) Color.white
                    else Color("#1a1c20")
                )
                color(
                    if (gewaehlterScreen.isNotBlank() && betreff.isNotBlank() && beschreibung.isNotBlank()) Color.black
                    else Color("#4a4d54")
                )
                fontWeight("bold")
                cursor("pointer")
                property("border", "none")
            }
            if (gewaehlterScreen.isBlank() || betreff.isBlank() || beschreibung.isBlank() || isSending) disabled()
            onClick { onSubmit() }
        }) { Text(if (isSending) "..." else "Anfrage unverbindlich absenden") }
    }
}

@Composable
internal fun CRRoleCard(titel: String, icon: String, onClick: () -> Unit) {
    var isHovered by remember { mutableStateOf(false) }

    Div({
        style {
            width(180.px)
            padding(32.px, 20.px)
            borderRadius(16.px)
            backgroundColor(Color.transparent)
            property("border", if (isHovered) "1px solid ${UISettings.ACCENT}" else "1px solid rgba(255,255,255,0.34)")
            property("transition", "border-color 0.18s ease")
            cursor("pointer")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            gap(20.px)
            property("user-select", "none")
        }
        onMouseEnter { isHovered = true }
        onMouseLeave { isHovered = false }
        onClick { onClick() }
    }) {
        Img(src = icon, attrs = {
            style {
                width(42.px)
                height(42.px)
                property("object-fit", "contain")
                property(
                    "filter",
                    if (isHovered)
                        UISettings.ICON_FILTER_ACCENT
                    else
                        "brightness(0) invert(1)"
                )
                property("transition", "filter 0.2s ease")
            }
        })
        Span({
            style {
                fontSize(15.px)
                fontWeight("600")
                color(Color.white)
            }
        }) { Text(titel) }
    }
}

@Composable
internal fun CRInput(value: String, placeholderText: String, onValueChange: (String) -> Unit) {
    Input(InputType.Text, attrs = {
        style {
            width(100.percent)
            height(54.px)
            padding(0.px, 18.px)
            borderRadius(10.px)
            backgroundColor(Color("#000000"))
            color(Color.white)
            property("border", "1px solid #2a2d34")
            property("box-sizing", "border-box")
            fontSize(15.px)
        }
        value(value)
        placeholder(placeholderText)
        onInput { onValueChange(it.value) }
    })
}

@Composable
internal fun CRTextArea(value: String, placeholderText: String, onValueChange: (String) -> Unit) {
    TextArea(attrs = {
        style {
            width(100.percent)
            minHeight(360.px)
            padding(18.px)
            borderRadius(10.px)
            backgroundColor(Color("#000000"))
            color(Color.white)
            property("border", "1px solid #2a2d34")
            property("box-sizing", "border-box")
            property("resize", "vertical")
            property("font-family", "inherit")
            fontSize(15.px)
            lineHeight("1.55")
        }
        value(value)
        placeholder(placeholderText)
        onInput { onValueChange(it.value) }
    })
}
